export const environment = {
  env: 'idp',
  enableSetRCsubaccount: false,
  enableDashboard: false,
  firstIndexPnl: true,
  sURL: 'https://idp-api.sadmincontrol.com/v1/api/',
  bURL: 'https://idp-api.sadmincontrol.com',
  mURL: 'https://idp-market.sadmincontrol.com',
  riskCalculatorURL: 'https://idp-feed-rust.sadmincontrol.com/risk_calculator',
  betTickerURL:'https://betticker',
  betTickerV1URL:'https://betticker-v1',
  pspAdminURL:'https://idp-psp-admin.freedemokit.com',
  kjsport9URL:'https://kjs-back.pkrsrv.com/webadmin-VDX0Xj',
  casinoApiBaseUrl: 'https://idp-casino.sadmincontrol.com',
  shivajiexchangeAdminURL: 'https://idp-admin.shivajiexchange.com',
  FARO_URL: 'https://idp-faro.sadmincontrol.com/collect',
  OTEL_ENABLED: true,
  tracePropagationTargets: [/^https:\/\/idp-api\.sadmincontrol\.com\//],
};
